import * as ambassadorWixEventsV1Order from './events-v1-order-orders.http.js';
import * as ambassadorWixEventsV1OrderTypes from './events-v1-order-orders.types.js';
import * as ambassadorWixEventsV1OrderUniversalTypes from './events-v1-order-orders.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function listOrders(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixEventsV1OrderUniversalTypes.ListOrdersRequest,
  ambassadorWixEventsV1OrderTypes.ListOrdersRequest,
  ambassadorWixEventsV1OrderUniversalTypes.ListOrdersResponse,
  ambassadorWixEventsV1OrderTypes.ListOrdersResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixEventsV1Order.listOrders(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/orders',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getOrder(): __PublicMethodMetaInfo<
  'GET',
  { eventId: string; orderNumber: string },
  ambassadorWixEventsV1OrderUniversalTypes.GetOrderRequest,
  ambassadorWixEventsV1OrderTypes.GetOrderRequest,
  ambassadorWixEventsV1OrderUniversalTypes.GetOrderResponse,
  ambassadorWixEventsV1OrderTypes.GetOrderResponse
> {
  const payload = { eventId: ':eventId', orderNumber: ':orderNumber' } as any;

  const getRequestOptions = ambassadorWixEventsV1Order.getOrder(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/events/{eventId}/orders/{orderNumber}',
    pathParams: { eventId: 'eventId', orderNumber: 'orderNumber' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateOrder(): __PublicMethodMetaInfo<
  'PATCH',
  { eventId: string; orderNumber: string },
  ambassadorWixEventsV1OrderUniversalTypes.UpdateOrderRequest,
  ambassadorWixEventsV1OrderTypes.UpdateOrderRequest,
  ambassadorWixEventsV1OrderUniversalTypes.UpdateOrderResponse,
  ambassadorWixEventsV1OrderTypes.UpdateOrderResponse
> {
  const payload = { eventId: ':eventId', orderNumber: ':orderNumber' } as any;

  const getRequestOptions = ambassadorWixEventsV1Order.updateOrder(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/events/{eventId}/orders/{orderNumber}',
    pathParams: { eventId: 'eventId', orderNumber: 'orderNumber' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateOrders(): __PublicMethodMetaInfo<
  'PATCH',
  { eventId: string },
  ambassadorWixEventsV1OrderUniversalTypes.BulkUpdateOrdersRequest,
  ambassadorWixEventsV1OrderTypes.BulkUpdateOrdersRequest,
  ambassadorWixEventsV1OrderUniversalTypes.BulkUpdateOrdersResponse,
  ambassadorWixEventsV1OrderTypes.BulkUpdateOrdersResponse
> {
  const payload = { eventId: ':eventId' } as any;

  const getRequestOptions =
    ambassadorWixEventsV1Order.bulkUpdateOrders(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/events/{eventId}/orders',
    pathParams: { eventId: 'eventId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function confirmOrder(): __PublicMethodMetaInfo<
  'POST',
  { eventId: string },
  ambassadorWixEventsV1OrderUniversalTypes.ConfirmOrderRequest,
  ambassadorWixEventsV1OrderTypes.ConfirmOrderRequest,
  ambassadorWixEventsV1OrderUniversalTypes.ConfirmOrderResponse,
  ambassadorWixEventsV1OrderTypes.ConfirmOrderResponse
> {
  const payload = { eventId: ':eventId' } as any;

  const getRequestOptions = ambassadorWixEventsV1Order.confirmOrder(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/events/{eventId}/orders/confirm',
    pathParams: { eventId: 'eventId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getSummary(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixEventsV1OrderUniversalTypes.GetSummaryRequest,
  ambassadorWixEventsV1OrderTypes.GetSummaryRequest,
  ambassadorWixEventsV1OrderUniversalTypes.GetSummaryResponse,
  ambassadorWixEventsV1OrderTypes.GetSummaryResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixEventsV1Order.getSummary(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/orders/summary',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function captureAuthorizedPayment(): __PublicMethodMetaInfo<
  'POST',
  { orderNumber: string },
  ambassadorWixEventsV1OrderUniversalTypes.CaptureAuthorizedPaymentRequest,
  ambassadorWixEventsV1OrderTypes.CaptureAuthorizedPaymentRequest,
  ambassadorWixEventsV1OrderUniversalTypes.CaptureAuthorizedPaymentResponse,
  ambassadorWixEventsV1OrderTypes.CaptureAuthorizedPaymentResponse
> {
  const payload = { orderNumber: ':orderNumber' } as any;

  const getRequestOptions =
    ambassadorWixEventsV1Order.captureAuthorizedPayment(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/events/orders/{orderNumber}/capture',
    pathParams: { orderNumber: 'orderNumber' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function voidAuthorizedPayment(): __PublicMethodMetaInfo<
  'POST',
  { orderNumber: string },
  ambassadorWixEventsV1OrderUniversalTypes.VoidAuthorizedPaymentRequest,
  ambassadorWixEventsV1OrderTypes.VoidAuthorizedPaymentRequest,
  ambassadorWixEventsV1OrderUniversalTypes.VoidAuthorizedPaymentResponse,
  ambassadorWixEventsV1OrderTypes.VoidAuthorizedPaymentResponse
> {
  const payload = { orderNumber: ':orderNumber' } as any;

  const getRequestOptions =
    ambassadorWixEventsV1Order.voidAuthorizedPayment(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/events/orders/{orderNumber}/void',
    pathParams: { orderNumber: 'orderNumber' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getCheckoutOptions(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixEventsV1OrderUniversalTypes.GetCheckoutOptionsRequest,
  ambassadorWixEventsV1OrderTypes.GetCheckoutOptionsRequest,
  ambassadorWixEventsV1OrderUniversalTypes.GetCheckoutOptionsResponse,
  ambassadorWixEventsV1OrderTypes.GetCheckoutOptionsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEventsV1Order.getCheckoutOptions(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/checkout/options',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listAvailableTickets(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixEventsV1OrderUniversalTypes.ListAvailableTicketsRequest,
  ambassadorWixEventsV1OrderTypes.ListAvailableTicketsRequest,
  ambassadorWixEventsV1OrderUniversalTypes.ListAvailableTicketsResponse,
  ambassadorWixEventsV1OrderTypes.ListAvailableTicketsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEventsV1Order.listAvailableTickets(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/checkout/available-tickets',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryAvailableTickets(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEventsV1OrderUniversalTypes.QueryAvailableTicketsRequest,
  ambassadorWixEventsV1OrderTypes.QueryAvailableTicketsRequest,
  ambassadorWixEventsV1OrderUniversalTypes.QueryAvailableTicketsResponse,
  ambassadorWixEventsV1OrderTypes.QueryAvailableTicketsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEventsV1Order.queryAvailableTickets(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/checkout/available-tickets/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function createReservation(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEventsV1OrderUniversalTypes.CreateReservationRequest,
  ambassadorWixEventsV1OrderTypes.CreateReservationRequest,
  ambassadorWixEventsV1OrderUniversalTypes.CreateReservationResponse,
  ambassadorWixEventsV1OrderTypes.CreateReservationResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEventsV1Order.createReservation(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/checkout/reservations',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function cancelReservation(): __PublicMethodMetaInfo<
  'DELETE',
  { id: string },
  ambassadorWixEventsV1OrderUniversalTypes.CancelReservationRequest,
  ambassadorWixEventsV1OrderTypes.CancelReservationRequest,
  ambassadorWixEventsV1OrderUniversalTypes.CancelReservationResponse,
  ambassadorWixEventsV1OrderTypes.CancelReservationResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixEventsV1Order.cancelReservation(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/checkout/reservations/{id}',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getInvoice(): __PublicMethodMetaInfo<
  'POST',
  { reservationId: string },
  ambassadorWixEventsV1OrderUniversalTypes.GetInvoiceRequest,
  ambassadorWixEventsV1OrderTypes.GetInvoiceRequest,
  ambassadorWixEventsV1OrderUniversalTypes.GetInvoiceResponse,
  ambassadorWixEventsV1OrderTypes.GetInvoiceResponse
> {
  const payload = { reservationId: ':reservationId' } as any;

  const getRequestOptions = ambassadorWixEventsV1Order.getInvoice(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/checkout/invoices/{reservationId}',
    pathParams: { reservationId: 'reservationId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function checkout(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEventsV1OrderUniversalTypes.CheckoutRequest,
  ambassadorWixEventsV1OrderTypes.CheckoutRequest,
  ambassadorWixEventsV1OrderUniversalTypes.CheckoutResponse,
  ambassadorWixEventsV1OrderTypes.CheckoutResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixEventsV1Order.checkout(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/checkout',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateCheckout(): __PublicMethodMetaInfo<
  'PATCH',
  { orderNumber: string },
  ambassadorWixEventsV1OrderUniversalTypes.UpdateCheckoutRequest,
  ambassadorWixEventsV1OrderTypes.UpdateCheckoutRequest,
  ambassadorWixEventsV1OrderUniversalTypes.UpdateCheckoutResponse,
  ambassadorWixEventsV1OrderTypes.UpdateCheckoutResponse
> {
  const payload = { orderNumber: ':orderNumber' } as any;

  const getRequestOptions = ambassadorWixEventsV1Order.updateCheckout(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/checkout/{orderNumber}',
    pathParams: { orderNumber: 'orderNumber' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function posCheckout(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEventsV1OrderUniversalTypes.PosCheckoutRequest,
  ambassadorWixEventsV1OrderTypes.PosCheckoutRequest,
  ambassadorWixEventsV1OrderUniversalTypes.PosCheckoutResponse,
  ambassadorWixEventsV1OrderTypes.PosCheckoutResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixEventsV1Order.posCheckout(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/pos-checkout',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Order as OrderOriginal,
  FormResponse as FormResponseOriginal,
  InputValue as InputValueOriginal,
  FormattedAddress as FormattedAddressOriginal,
  Address as AddressOriginal,
  AddressStreetOneOf as AddressStreetOneOfOriginal,
  StreetAddress as StreetAddressOriginal,
  AddressLocation as AddressLocationOriginal,
  Subdivision as SubdivisionOriginal,
  SubdivisionType as SubdivisionTypeOriginal,
  SubdivisionTypeWithLiterals as SubdivisionTypeWithLiteralsOriginal,
  StandardDetails as StandardDetailsOriginal,
  OrderStatus as OrderStatusOriginal,
  OrderStatusWithLiterals as OrderStatusWithLiteralsOriginal,
  Money as MoneyOriginal,
  TicketingTicket as TicketingTicketOriginal,
  CheckIn as CheckInOriginal,
  GuestDetails as GuestDetailsOriginal,
  FormSubmission as FormSubmissionOriginal,
  ChannelType as ChannelTypeOriginal,
  ChannelTypeWithLiterals as ChannelTypeWithLiteralsOriginal,
  TicketDetails as TicketDetailsOriginal,
  Invoice as InvoiceOriginal,
  Item as ItemOriginal,
  Discount as DiscountOriginal,
  DiscountItem as DiscountItemOriginal,
  DiscountItemDiscountOneOf as DiscountItemDiscountOneOfOriginal,
  CouponDiscount as CouponDiscountOriginal,
  PaidPlanDiscount as PaidPlanDiscountOriginal,
  PaidPlanDiscountDiscountOneOf as PaidPlanDiscountDiscountOneOfOriginal,
  PercentDiscount as PercentDiscountOriginal,
  Tax as TaxOriginal,
  TaxType as TaxTypeOriginal,
  TaxTypeWithLiterals as TaxTypeWithLiteralsOriginal,
  Fee as FeeOriginal,
  FeeName as FeeNameOriginal,
  FeeNameWithLiterals as FeeNameWithLiteralsOriginal,
  FeeType as FeeTypeOriginal,
  FeeTypeWithLiterals as FeeTypeWithLiteralsOriginal,
  PaymentDetails as PaymentDetailsOriginal,
  PaymentTransaction as PaymentTransactionOriginal,
  ScheduledActionEnumAction as ScheduledActionEnumActionOriginal,
  ScheduledActionEnumActionWithLiterals as ScheduledActionEnumActionWithLiteralsOriginal,
  Action as ActionOriginal,
  ActionWithLiterals as ActionWithLiteralsOriginal,
  GiftCardPaymentDetails as GiftCardPaymentDetailsOriginal,
  BalanceSummary as BalanceSummaryOriginal,
  OrderDeleted as OrderDeletedOriginal,
  OrderType as OrderTypeOriginal,
  OrderTypeWithLiterals as OrderTypeWithLiteralsOriginal,
  Ticket as TicketOriginal,
  OnlineConferencingLogin as OnlineConferencingLoginOriginal,
  ListOrdersRequest as ListOrdersRequestOriginal,
  OrderFieldset as OrderFieldsetOriginal,
  OrderFieldsetWithLiterals as OrderFieldsetWithLiteralsOriginal,
  OrderTag as OrderTagOriginal,
  OrderTagWithLiterals as OrderTagWithLiteralsOriginal,
  ListOrdersResponse as ListOrdersResponseOriginal,
  FacetCounts as FacetCountsOriginal,
  OrderFacets as OrderFacetsOriginal,
  OrderFacetCounts as OrderFacetCountsOriginal,
  Counts as CountsOriginal,
  GetOrderRequest as GetOrderRequestOriginal,
  GetOrderResponse as GetOrderResponseOriginal,
  CalendarLinks as CalendarLinksOriginal,
  UpdateOrderRequest as UpdateOrderRequestOriginal,
  UpdateOrderResponse as UpdateOrderResponseOriginal,
  OrderUpdated as OrderUpdatedOriginal,
  BulkUpdateOrdersRequest as BulkUpdateOrdersRequestOriginal,
  BulkUpdateOrdersResponse as BulkUpdateOrdersResponseOriginal,
  ConfirmOrderRequest as ConfirmOrderRequestOriginal,
  ConfirmOrderResponse as ConfirmOrderResponseOriginal,
  GetSummaryRequest as GetSummaryRequestOriginal,
  GetSummaryResponse as GetSummaryResponseOriginal,
  TicketSales as TicketSalesOriginal,
  GetInvoicePreviewRequest as GetInvoicePreviewRequestOriginal,
  RawHttpResponse as RawHttpResponseOriginal,
  HeadersEntry as HeadersEntryOriginal,
  GetPaymentInfoRequest as GetPaymentInfoRequestOriginal,
  GetPaymentInfoResponse as GetPaymentInfoResponseOriginal,
  PaymentTransactionSummary as PaymentTransactionSummaryOriginal,
  PaymentTransactionEvent as PaymentTransactionEventOriginal,
  CaptureAuthorizedPaymentRequest as CaptureAuthorizedPaymentRequestOriginal,
  CaptureAuthorizedPaymentResponse as CaptureAuthorizedPaymentResponseOriginal,
  VoidAuthorizedPaymentRequest as VoidAuthorizedPaymentRequestOriginal,
  VoidAuthorizedPaymentResponse as VoidAuthorizedPaymentResponseOriginal,
  FindOrderByReservationIdRequest as FindOrderByReservationIdRequestOriginal,
  FindOrderByReservationIdResponse as FindOrderByReservationIdResponseOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  OrderConfirmed as OrderConfirmedOriginal,
  OrderPaid as OrderPaidOriginal,
  ReservationCreated as ReservationCreatedOriginal,
  ReservationStatus as ReservationStatusOriginal,
  ReservationStatusWithLiterals as ReservationStatusWithLiteralsOriginal,
  TicketQuantity as TicketQuantityOriginal,
  ReservationCount as ReservationCountOriginal,
  ReservationUpdated as ReservationUpdatedOriginal,
  GetCheckoutOptionsRequest as GetCheckoutOptionsRequestOriginal,
  GetCheckoutOptionsResponse as GetCheckoutOptionsResponseOriginal,
  ListAvailableTicketsRequest as ListAvailableTicketsRequestOriginal,
  State as StateOriginal,
  StateWithLiterals as StateWithLiteralsOriginal,
  ListAvailableTicketsResponse as ListAvailableTicketsResponseOriginal,
  ResponseMetaData as ResponseMetaDataOriginal,
  TicketDefinition as TicketDefinitionOriginal,
  Dashboard as DashboardOriginal,
  WixFeeConfig as WixFeeConfigOriginal,
  TicketSalePeriod as TicketSalePeriodOriginal,
  TicketSaleStatus as TicketSaleStatusOriginal,
  TicketSaleStatusWithLiterals as TicketSaleStatusWithLiteralsOriginal,
  TicketPricing as TicketPricingOriginal,
  TicketPricingPriceOneOf as TicketPricingPriceOneOfOriginal,
  PricingOptions as PricingOptionsOriginal,
  PricingOption as PricingOptionOriginal,
  Type as TypeOriginal,
  TypeWithLiterals as TypeWithLiteralsOriginal,
  QueryAvailableTicketsRequest as QueryAvailableTicketsRequestOriginal,
  TicketDefinitionFieldset as TicketDefinitionFieldsetOriginal,
  TicketDefinitionFieldsetWithLiterals as TicketDefinitionFieldsetWithLiteralsOriginal,
  QueryAvailableTicketsResponse as QueryAvailableTicketsResponseOriginal,
  CreateReservationRequest as CreateReservationRequestOriginal,
  TicketReservationQuantity as TicketReservationQuantityOriginal,
  CreateReservationResponse as CreateReservationResponseOriginal,
  TicketReservation as TicketReservationOriginal,
  CancelReservationRequest as CancelReservationRequestOriginal,
  CancelReservationResponse as CancelReservationResponseOriginal,
  GetInvoiceRequest as GetInvoiceRequestOriginal,
  DiscountRequest as DiscountRequestOriginal,
  PaidPlanBenefit as PaidPlanBenefitOriginal,
  GetInvoiceResponse as GetInvoiceResponseOriginal,
  DiscountErrors as DiscountErrorsOriginal,
  Error as ErrorOriginal,
  GiftCardErrors as GiftCardErrorsOriginal,
  GiftCardErrorsError as GiftCardErrorsErrorOriginal,
  CheckoutRequest as CheckoutRequestOriginal,
  Buyer as BuyerOriginal,
  Guest as GuestOriginal,
  CheckoutOptions as CheckoutOptionsOriginal,
  CheckoutResponse as CheckoutResponseOriginal,
  OrderInitiated as OrderInitiatedOriginal,
  UpdateCheckoutRequest as UpdateCheckoutRequestOriginal,
  UpdateCheckoutResponse as UpdateCheckoutResponseOriginal,
  OrderPageUrls as OrderPageUrlsOriginal,
  PosCheckoutRequest as PosCheckoutRequestOriginal,
  PosCheckoutResponse as PosCheckoutResponseOriginal,
  GetReservationRequest as GetReservationRequestOriginal,
  GetReservationResponse as GetReservationResponseOriginal,
  Reservation as ReservationOriginal,
  ConfirmReservationRequest as ConfirmReservationRequestOriginal,
  ConfirmReservationResponse as ConfirmReservationResponseOriginal,
  ExpireReservationRequest as ExpireReservationRequestOriginal,
  ExpireReservationResponse as ExpireReservationResponseOriginal,
  QueryEventsWithPaidReservationsRequest as QueryEventsWithPaidReservationsRequestOriginal,
  EventKey as EventKeyOriginal,
  QueryEventsWithPaidReservationsResponse as QueryEventsWithPaidReservationsResponseOriginal,
  UpdateOrderApplicationErrors as UpdateOrderApplicationErrorsOriginal,
  BulkUpdateOrdersApplicationErrors as BulkUpdateOrdersApplicationErrorsOriginal,
  ConfirmOrderApplicationErrors as ConfirmOrderApplicationErrorsOriginal,
  CaptureAuthorizedPaymentApplicationErrors as CaptureAuthorizedPaymentApplicationErrorsOriginal,
  VoidAuthorizedPaymentApplicationErrors as VoidAuthorizedPaymentApplicationErrorsOriginal,
} from './events-v1-order-orders.types.js';
